import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './ui/SectionHeading';
import { modules } from '../data/modules';
import { totalVolumes } from '../data/offer';
export function ModulesSection() {
  return <section className="py-16 sm:py-20" aria-labelledby="modules-title" data-id="element-118" data-mp="1iwcxjc03p0fu">
      <div className="mx-auto max-w-6xl px-4" data-id="element-119" data-mp="1dx07kidxnd91">
        <SectionHeading id="modules-title" data-id="element-120" data-mp="1dybakfzk0gz3">I {totalVolumes} <span className="text-primary" data-id="element-121" data-mp="2bkihhwjbylem">Volumi Completi</span></SectionHeading>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-122" data-mp="26lfaw7npc74j">
          {modules.map((module, index) => {
          const Icon = module.icon;
          return <motion.article key={module.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.15
          }} transition={{
            duration: 0.3,
            delay: index % 3 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col rounded-2xl border border-primary/20 bg-background/55 p-6 shadow-lg shadow-black/30 backdrop-blur-md" data-id="element-123" data-mp="21k83i9ph19ye" data-mpi={index}>
                <div className="flex items-center gap-3" data-id="element-124" data-mp="1ns8vk4kg2pth">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-primary/40 bg-surface/60 text-primary" data-id="element-125" data-mp="18w16apu6iy7c">
                    <Icon className="h-5 w-5 drop-shadow-glow" aria-hidden="true" data-id="element-126" data-mp="104r1g2dpjfnc" />
                  </span>
                  <p className="text-xs font-bold uppercase tracking-[.14em] text-accent" data-id="element-127" data-mp="14v7fnopcr5ar">Volume {module.number}</p>
                </div>
                <h3 className="mt-4 text-xl font-extrabold uppercase leading-tight text-foreground" data-id="element-128" data-mp="q7mgu6zifs8n">{module.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-muted" data-id="element-129" data-mp="v663k9lxh822">{module.summary}</p>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}